import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/20/solid";

export default function Pagination({
  totalRecords,
  recordPerPage,
  currentPage,
  paginate,
}) {
  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(totalRecords / recordPerPage); i++) {
    pageNumbers.push(i);
  }
  
  const totalPages = pageNumbers.length;
  const isFirstPage = currentPage <= 1;
  const isLastPage = currentPage >= totalPages;
  const firstRecord = totalRecords > 0 ? currentPage * recordPerPage - recordPerPage + 1 : 0;
  const lastRecord = Math.min(currentPage * recordPerPage, totalRecords);
  
  let pageNum =
    pageNumbers.length >= 10
      ? pageNumbers
          ?.slice(
            currentPage <= 10 ? 0 : currentPage - 8,
            currentPage <= 10 ? 10 : currentPage + 2
          )
          ?.concat(`...`)
          ?.concat(`${pageNumbers.length}`)
      : pageNumbers;
  return (
    <div className="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6">
      <div className="flex flex-1 justify-between sm:hidden">
        <a 
          onClick={() => {
            if (!isFirstPage) {
              paginate(currentPage - 1);
            }
          }}
          className={`relative inline-flex items-center rounded-md border border-gray-300 px-4 py-2 text-sm font-medium ${
            isFirstPage 
              ? 'bg-gray-100 text-gray-400 cursor-not-allowed' 
              : 'bg-white text-gray-700 hover:bg-gray-50 cursor-pointer'
          }`}
        >
          Previous
        </a>
        <a 
          onClick={() => {
            if (!isLastPage) {
              paginate(currentPage + 1);
            }
          }}
          className={`relative ml-3 inline-flex items-center rounded-md border border-gray-300 px-4 py-2 text-sm font-medium ${
            isLastPage 
              ? 'bg-gray-100 text-gray-400 cursor-not-allowed' 
              : 'bg-white text-gray-700 hover:bg-gray-50 cursor-pointer'
          }`}
        >
          Next
        </a>
      </div>
      <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
        <div>
          <p className="text-sm text-gray-700">
            Showing{" "}
            <span className="font-medium">
              {firstRecord}
            </span>{" "}
            to <span className="font-medium">{lastRecord}</span>{" "}
            of <span className="font-medium">{totalRecords}</span> results
          </p>
        </div>
        <div>
          <nav
            className="isolate inline-flex -space-x-px rounded-md shadow-sm"
            aria-label="Pagination"
          >
            <a
              onClick={() => {
                if (!isFirstPage) {
                  paginate(currentPage - 1);
                }
              }}
              className={`relative inline-flex items-center rounded-l-md border border-gray-300 px-2 py-2 text-sm font-medium focus:z-20 ${
                isFirstPage
                  ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                  : 'bg-white text-gray-500 hover:bg-gray-50 cursor-pointer'
              }`}
            >
              <span className="sr-only">Previous</span>
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
            </a>
            {/* Current: "z-10 bg-indigo-50 border-indigo-500 text-indigo-600", Default: "bg-white border-gray-300 text-gray-500 hover:bg-gray-50" */}
            {pageNum?.map((number, index) => (
              <a
                key={index}
                onClick={() => {
                  if (number !== "...") {
                    paginate(Number(number));
                  }
                }}
                className={
                  currentPage == number
                    ? "bg-blue border-red-300 text-red-500 hover:bg-blue-200 relative inline-flex items-center px-4 py-2 border text-sm font-medium cursor-pointer"
                    : number === "..."
                    ? "bg-white border-gray-300 text-gray-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium cursor-default"
                    : "bg-white border-gray-300 text-gray-500 hover:bg-blue-200 relative inline-flex items-center px-4 py-2 border text-sm font-medium cursor-pointer"
                }
              >
                {number}
              </a>
            ))}
            <a
              onClick={() => {
                if (!isLastPage) {
                  paginate(currentPage + 1);
                }
              }}
              className={`relative inline-flex items-center rounded-r-md border border-gray-300 px-2 py-2 text-sm font-medium focus:z-20 ${
                isLastPage
                  ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                  : 'bg-white text-gray-500 hover:bg-gray-50 cursor-pointer'
              }`}
            >
              <span className="sr-only">Next</span>
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
            </a>
          </nav>
        </div>
      </div>
    </div>
  );
}
